import React, { useContext, Suspense, lazy, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Study } from './Edu/Study';
import { PublicSocial } from './PublicSocial';
import { Settings } from './Settings';
import { MeInfo } from './SocialComponents/MeInfo';
import { PersonaInfo } from './SocialComponents/PersonaInfo';
import { UserInfo } from './SocialComponents/UseerInfo';
import { UserNetwork } from './SocialComponents/UserNetwork';
import { Start, UncertainNarrativeBridge } from './Start';
import { Background } from './UiKit/Background';
import { useUncertainPageDesign } from '../contexts/uncertainContext';
import { Preloader, Preloader0 } from './UiKit/kit';
import { MobMenu } from './UiKit/MobMenu';
import { Pop } from './UiKit/Pop';
import { Topbar } from './UiKit/Topbar';
import {
  _getPublicUser,
  applyDesignTheme,
  AVATAR_TOKEN_LENGTH,
  findDesignForUseravatarId,
  parseAvatar,
  parseNewDesign,
  resolveDesign,
  USER_TOKEN_LENGTH
} from './utilsDesign';
import { VideoPop } from './VideoPop';
import { WithRectification } from './WithRectification';
import { useIsMobile } from './useIsMobile';
import { PublicSignup } from './PublicSignup';

const LazySocial = lazy(() => import('./Social'));

function ThemedBackground({ avatar, ...props }) {
  const design = useUncertainPageDesign(avatar);
  return <Background {...props} design={design} />;
}




export function Design(props) {

  const context = { ...useContext(SocialContext), ...useContext(StateContext) };
  const {
    publ,
    user,
    avatar,
    isMe,
    useravatarId,
    loading
  } = { ...props };


  // const design =
  //   cachedDesign ? cachedDesign
  //   : avatar ? context.x.getDesign(avatar) : null;
  // const design = avatar ? context.x.getDesign(avatar) : null;

  //if array
  // const design = (avatar && avatar.design && avatar.design[0]) ? avatar.design[0] : default_design;

  const design = resolveDesign(avatar?.design);


  const [designObject, setDesignObject] = useState(design)

  useEffect(() => {
    // console.log('context.avatar.design = ', context.avatar ? context.avatar.design : null);
  }, [context.avatar])


  // const design = avatar && avatar.design ? avatar.design : null;

  // useEffect(() => {
  //   context.setState.setCalcShown((!avatar || !avatar.dob) ? true : false)
  // }, [avatar])

  useEffect(() => {
    // console.log('design 🧩 = ', design);
  }, [design])


  // console.log('context.me123 = ', context.me);
  const location = useLocation(); 
  const isStudy = location.pathname.includes('study');


  return (
    <UncertainNarrativeBridge avatar={avatar} isMe={isMe}>
    <>





      <div className="l_panel">

        {/* {!avatar && <Preloader0 style={{ paddingTop: '4em' }}><Preloader width={80} height={80} /></Preloader0>} */}

        {avatar && <>
          <div className={`x_edu0 ${isStudy ? 'x_edu0--study' : ''}`}>





            {Boolean(avatar) &&
              <Start
                user={user}
                avatar={avatar}
                publ={publ}
                useravatarId={useravatarId}
                isMe={isMe}
                design={design}
                loading={avatar.token && context.updatingAva === avatar.token}
              >

              </Start>}
          </div>

        </>
        }

      </div>

    </>
    </UncertainNarrativeBridge>
  )
}











export const WithDOB = React.memo(({ children }) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  let { useravatarId } = useParams();
  if (useravatarId === 'me') useravatarId = context.me.user.token;

  const $ui = context.$ui;
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState({});
  const [avatar, setAvatar] = useState({});
  const [followings, setFollowings] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [scrolled, setScrolled] = useState(false);

  const [newUser, setNewUser] = useState();

  // Create a ref to store the current useravatarId
  const currentIdRef = useRef(useravatarId);



  const removeLanguageParam = () => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    params.delete('ln');
    const newHash = params.toString();
    window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
  };

  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    const languageParam = params.get('ln');
    if (languageParam !== context.language && context.languages.includes(languageParam)) {
      context.setLanguage(languageParam)
    }
    // removeLanguageParam()
  }, [location]);



  const scrollable = useRef(null);



  const fetchCallback = (newUser, refetch) => {
    // Check if useravatarId has changed since the request was made
    if (currentIdRef.current !== useravatarId) {
      // If it has changed, abort the callback execution
      // console.log('Aborting fetchCallback due to useravatarId change');
      return;
    }

    if (!newUser) {
      navigate('/404');
      return;
    }

    newUser.avatar = parseAvatar(newUser.avatar, Boolean(newUser.user?.isMe || newUser.avatar?.my || newUser.avatar?.isMe))
    // console.log('newUser.avatar = ', newUser.avatar);

    setNewUser(newUser)
  };

  useEffect(() => {
    if (newUser && useravatarId === newUser.user.token) {

      updateUser(newUser)

      //TODO: временно новый диз
      // getNewDesign(newUser.avatar.dob, (newDesign) => updateUser({
      //   ...newUser,
      //   avatar: mergeOldNewDesign(newUser.avatar, newDesign)
      // }))
    }
  }, [newUser, useravatarId])




  const mergeOldNewDesign = (oldAva, newDesign) => {

    // const variables = getVariables(newDesign)


    // oldAva.design = parseNewDesign(newDesign);
    oldAva = parseAvatar(oldAva);

    return oldAva


  }



  const updateUser = (newUser) => {
    setUser(newUser.user);
    let ava = newUser.avatar;
    if (!ava) {
      navigate('../');
      return;
    }
    ava.design = resolveDesign(ava.design);
    // if (!refetch || (refetch === newUser.avatar.token || refetch === newUser.user.token)) {
    setAvatar(ava);
    applyDesignTheme(ava.design);
    setFollowings(newUser.followings ? newUser.followings : []);
    // console.log('newUser.followings = ', newUser.followings);
    setFollowers(newUser.followers ? newUser.followers : []);
    // }
  }





  const getUserAvatar = async (useravatarId, refetch = false) => {

    // console.log('context.me = ', context.me);
    if (context.me) {
      if (useravatarId.length === USER_TOKEN_LENGTH) {
        //USER
        currentIdRef.current = useravatarId;
        context.x.fetchUser(useravatarId, (newUser) => {
          if (!newUser.design || (newUser.design && newUser.design.id === 'dummy')) {
            context.setState.setHighlighted()
            context.setState.setSearch()
          }
          fetchCallback(newUser);
          context.setState.setShowHistory(useravatarId)
        }, refetch);

      } else if (useravatarId.length === AVATAR_TOKEN_LENGTH) {
        //AVATAR
        setUser()
        let ava = await context.x.getAvatar(useravatarId)
        if (!ava) {
          navigate('../');
          return;
        }
        // parseAvatar converts the raw design (meta/dd) into the parsed
        // shape and assigns design.id; it also falls back to default_design
        // when there is genuinely no design. Checking design.id before
        // parsing was wrong because the raw API design has no top-level id.
        ava = parseAvatar(ava, true);
        setAvatar(ava)
        applyDesignTheme(ava.design);
        context.setState.setShowHistory(useravatarId)
      }

    }



    if (!context.me) {
      if (useravatarId.length === USER_TOKEN_LENGTH) {

        const getUserCallback = (newUser) => {
          setUser(newUser.user)
          // newUser.avatar.dob = newUser.avatar.dob ? newUser.avatar.dob.replace(' ', 'T') : '';
          // newUser.avatar.design = parseNewDesign(newUser.avatar.design);
          newUser.avatar = parseAvatar(newUser.avatar);
          setAvatar(newUser.avatar);
          applyDesignTheme(newUser.avatar.design);
        }

        _getPublicUser(useravatarId, getUserCallback)

      } else if (useravatarId.length === AVATAR_TOKEN_LENGTH) {
        // console.log('avatar = ', useravatarId);
      }


    }


  };





  useEffect(() => {
    getUserAvatar(useravatarId);
  }, [useravatarId, context.updatingAva]);

  useEffect(() => {
    const meAva = context.me?.avatar;
    if (!meAva?.dob_start || !meAva?.dob_end) return;
    const sameAvatar = meAva.token && meAva.token === avatar?.token;
    const sameUser = context.me?.user?.token === useravatarId;
    if (!sameAvatar && !sameUser) return;
    if (meAva.dob_start === avatar?.dob_start && meAva.dob_end === avatar?.dob_end) return;
    setAvatar((prev) => ({
      ...prev,
      dob: meAva.dob || prev.dob,
      dob_start: meAva.dob_start,
      dob_end: meAva.dob_end,
      my: true,
      isMe: true,
    }));
  }, [context.me?.avatar?.dob_start, context.me?.avatar?.dob_end, context.me?.avatar?.dob, context.me?.avatar?.token, avatar?.token, avatar?.dob_start, avatar?.dob_end, useravatarId]);

  useEffect(() => {
    getUserAvatar(useravatarId, true);
  }, [context.me]);

  // Keep WithDOB avatar in sync when the cached list is patched
  // (e.g. rename) — updatingAva alone can race ahead of loadAvatars.
  useEffect(() => {
    if (!useravatarId || useravatarId.length !== AVATAR_TOKEN_LENGTH) return;
    const found = context.avatars?.find((one) => one.avatar?.token === useravatarId)?.avatar;
    if (!found) return;
    setAvatar((prev) => {
      if (
        prev?.name === found.name
        && prev?.dob === found.dob
        && prev?.city_id === found.city_id
        && prev?.design?.id === found.design?.id
        && prev?.privateNote === found.privateNote
        && prev?.image === found.image
      ) {
        return prev;
      }
      const ava = parseAvatar({ ...found }, true);
      applyDesignTheme(ava.design);
      return ava;
    });
  }, [context.avatars, useravatarId]);


  useEffect(() => {
    if (avatar && avatar.my) {
      context.setState.setCalcShown((!avatar.dob) ? true : false)
    }
  }, [avatar])




  useLayoutEffect(() => {
    applyDesignTheme(avatar?.design);
  }, [avatar?.design?.type, avatar?.design?.id, avatar?.token]);

  useLayoutEffect(() => {
    const design = findDesignForUseravatarId(useravatarId, context);
    if (design) applyDesignTheme(design);
  }, [useravatarId, context.cachedUsers, context.avatars]);

  const isStudy = location.pathname.includes('study');
  const isInfo = location.pathname.includes('info');
  const isSettings = location.pathname.includes('settings');
  const isFollowingPage = location.pathname.includes('following');
  const isFollowersPage = location.pathname.includes('followers');



  const world = location.pathname.includes('world');
  const network = location.pathname.includes('network');
  const bodygraphs = location.pathname.includes('bodygraphs');
  const history = location.pathname.includes('history');
  const pentas = location.pathname.includes('pentas');

  //TODO: urls better
  useEffect(() => {
    if (world) context.setState.showPeoplePanel(['world'])
    if (network) context.setState.showPeoplePanel(['people', 'followers'])
    if (bodygraphs) context.setState.showPeoplePanel(['bodygraphs'])
    if (history) context.setState.showPeoplePanel(['history'])
    if (pentas) context.setState.showPeoplePanel(['pentas'])
  }, [world, network, bodygraphs, history, pentas])

  const isMobile = useIsMobile(768);
  const panelFromHash = useMemo(() => {
    const params = new URLSearchParams(location.hash.slice(1));
    return params.get('p');
  }, [location.hash]);
  const peoplePanelOpen = Boolean(context.state.peoplePanel);
  const shouldMountSocial = !isMobile || Boolean(panelFromHash) || peoplePanelOpen;


  // console.log('context.me123 = ', context.me123);
  
  
  
  return (
    <UncertainNarrativeBridge
      avatar={avatar}
      isMe={Boolean(user?.isMe || avatar?.my || avatar?.isMe)}
    >
    <>



    {Boolean(context.me) && <MobMenu avatar={avatar} />}
    



      {!avatar.design && (
        <>
          <Preloader0 style={{ zIndex: 100, position: 'absolute' }}>
            <Preloader width={80} height={80} /> {$ui('loading')}...
          </Preloader0>
        </>
      )}


      <VideoPop />

      {avatar && avatar.design && (
        <>



            <div className={`${!context.state.peoplePanel ? "x_layout" : "x_layout x_layout--people"} ${!Boolean(context.me)? 'x_layout--public' : ''} ${isStudy ? ' x_layout--study' : ''}`}
              // onClick={() => handleCloseInfoPop()}
            >


            {!Boolean(context.me) && <PublicSignup />}

            <Topbar
              user={user}
              avatar={avatar}
              mode2={scrolled}
              logoColor="#002bff"
              logoBgColor="#000"
              logoWaveColor="#002bff"
              logoBpm={20}
            />

            {isInfo
              && !user
              &&
              <Pop
                // title={$ui('pop_edit_avatar_header')}
                // icon='person_add'
                handleClose={() => navigate('../')}
              >

                <PersonaInfo
                  user={user ? user : null}
                  avatar={avatar}
                  handleClose={() => navigate('../')}
                />

              </Pop>}

          {isSettings
            && user.isMe
            && <Pop
              title={$ui('settings')}
              // icon='person_add'
              handleClose={() => navigate('../')}
            >
              <Settings
                user={user ? user : null}
                avatar={avatar}
                handleClose={() => navigate('../')}
              />
            </Pop>}


          {isInfo
            && user
            && user.isMe
            && <Pop
                // title={$ui('pop_edit_me_header')}
                // icon='person_add'
                handleClose={() => navigate('../')}
              >

                <MeInfo
                  user={context.me.user}
                  title={$ui('pop_edit_me_header')}
                  avatar={avatar}
                  handleClose={() => navigate('../')}
                />

            </Pop>}

          {isInfo
            && user
            && !user.isMe
            && <Pop
                // title={$ui('pop_edit_me_header')}
                // icon='person_add'
                handleClose={() => navigate('../')}
              >

                  <UserInfo
                    title={$ui('pop_edit_avatar_header')}
                  user={user ? user : null}
                  avatar={avatar}
                  handleClose={() => navigate('../')}
                />

              </Pop>}

              {avatar && <WithRectification avatar={avatar}>
                <Study
                  user={user ? user : null}
                  avatar={avatar}
                  handleClose={() => navigate('../')}
                />
              </WithRectification>}



          {isFollowersPage && <Pop
            title={$ui('people_people')}
            icon='hub'
              handleClose={() => navigate('../')}
              type="followers"
            >
                <UserNetwork
                  useravatarId={useravatarId}
                    user={user}
                    startState="followers"
                />
          </Pop>}

            {isFollowingPage && <Pop
            title={$ui('people_people')}
            icon='hub'
              handleClose={() => navigate('../')}
            type="followings"
            >
                <UserNetwork
                  useravatarId={useravatarId}
                  user={user}
                  startState="followings"
                />
            </Pop>}




            {/* {typeof context.cachedDesigns !== 'object' && <Preloader0 style={{ paddingTop: '4em' }}><Preloader width={80} height={80} /></Preloader0>} */}

            <>

            {
              Boolean(context.me) 
              && Boolean(shouldMountSocial)
              && (
                <Suspense fallback={<Preloader0 style={{ zIndex: 100, position: 'absolute' }}><Preloader width={80} height={80} /> {$ui('loading')}...</Preloader0>}>
                  <LazySocial />
                </Suspense>
              )
            }

            {/* {Boolean(context.me) && <Social />} */}


            {/* {!Boolean(context.me) && Public<Social />} */}


              <div className={!context.state.peoplePanel ? "x_edu_block" : "x_edu_block x_edu_block--open"}>
                <div className="x_edu_c">
                  <div className="l_panel">
                      <div className={`x_edu0 ${isStudy ? 'x_edu0--study' : ''}`}
                        ref={scrollable}
                      // onClick={() => handleCloseInfoPop()}
                      >





                    <Start
                      user={user}
                      avatar={avatar}
                      isMe={Boolean(user?.isMe || avatar?.my || avatar?.isMe)}
                      followings={followings}
                      followers={followers}
                      loading={context.updatingAva === avatar.token}
                      refetch={(id) => getUserAvatar(id, true)}
                    >
                        {/* <Background style={{ zIndex: -1 }} design={avatar.design}></Background> */}
                      </Start>




                      <WithRectification avatar={avatar}>
                        <ThemedBackground
                          avatar={avatar}
                          className={'x_design_bg'}
                          style={{ zIndex: -1 }}
                          aura={false}
                        />
                      </WithRectification>



                    </div>
                  </div>
                </div>
              </div>
            </>





          </div>

          <WithRectification avatar={avatar}>
            <ThemedBackground
              avatar={avatar}
              className={'x_design_bg_global'}
              key={avatar.token}
              style={{ zIndex: -1 }}
              aura={false}
              theme
            />
          </WithRectification>



        </>
      )}

      </>
    </UncertainNarrativeBridge>
  );
});



